







































import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import { filter } from 'ramda'
import dayjs from 'dayjs'
import {
  getModule,
} from 'vuex-module-decorators'
import firebase from 'firebase'
import { TaskType } from '../../types'
import SingleTask from './SingleTask.vue'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'

const isIncomplete = (x:TaskType) => x.completed === null
const isComplete = (x:TaskType) => x.completed !== null
const isDueToday = (x:TaskType) => x.due === dayjs(new Date()).format('YYYY-MM-DD') && !isComplete(x)

@Component({
  components: {
    SingleTask,
  },
})
export default class TaskWrapper extends Mixins(MainMixin) {
  get allTasks() {
    return this.$store.getters.employeeTasks || []
  }

  get tasksDueToday() {
    return filter(isDueToday, this.allTasks)
  }

  get completedTasks() {
    return filter(isComplete, this.allTasks)
  }

  get incompleteTasks() {
    return filter(isIncomplete, this.allTasks)
  }

  activeTab = 'due'

  get tasksStatus() {
    return this.$store.getters.numberEmployeeTasks
  }

  get theRoute() {
    return this.$route.name
  }
}

